export class Logger {
  static debug(page: string, message: string, data: any = {}) {
    console.log(`[${window.location.host}]`, '[DEBUG]', `[${page}]`, message, data);

    const msg = `[${window.location.host}] [DEBUG] [${page}] ${message}`;
    return msg;
  }
}
